import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wl-taste-profile__profile"
}
const _hoisted_2 = {
  key: 0,
  class: "wl-taste-profile__headline"
}
const _hoisted_3 = { class: "wl-taste-profile__histogram" }
const _hoisted_4 = { class: "wl-taste-profile__histogram-label" }
const _hoisted_5 = { class: "wl-taste-profile__histogram-bar" }
const _hoisted_6 = {
  key: 1,
  class: "wl-taste-profile__aroma"
}
const _hoisted_7 = {
  key: 0,
  class: "wl-taste-profile__headline"
}
const _hoisted_8 = { class: "wl-taste-profile__aroma-list" }
const _hoisted_9 = { class: "wl-taste-profile__aroma-label" }
const _hoisted_10 = {
  key: 2,
  class: "wl-taste-profile__style"
}
const _hoisted_11 = {
  key: 0,
  class: "wl-taste-profile__headline"
}
const _hoisted_12 = { class: "wl-taste-profile__style-content" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "wl-taste-profile__style-text"
}
const _hoisted_15 = {
  key: 0,
  class: "wl-taste-profile__style-taste"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 1,
  class: "wl-taste-profile__style-aftertaste"
}
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wl-taste-profile", 'wl-taste-profile--' + _ctx.taste.type.toLowerCase()])
  }, [
    (_ctx.taste.profile)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          (_ctx.isHeadlineVisible)
            ? (_openBlock(), _createElementBlock("header", _hoisted_2, _toDisplayString(_ctx.$t('wl_taste_profile.head.profile')), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taste.profile, (entry) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "wl-taste-profile__histogram-line",
                key: entry.label
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(entry.label), 1 /* TEXT */),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: "wl-taste-profile__histogram-fill",
                    style: _normalizeStyle(`width: ${entry.value * 100}%`)
                  }, "\n               \n            ", 4 /* STYLE */)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[9] || (_cache[9] = _createTextVNode()),
    (_ctx.taste.aroma && _ctx.taste.aroma.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          (_ctx.isHeadlineVisible)
            ? (_openBlock(), _createElementBlock("header", _hoisted_7, _toDisplayString(_ctx.$t('wl_taste_profile.head.aroma')), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taste.aroma, (aroma) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "wl-taste-profile__aroma-item",
                key: aroma.label
              }, [
                _createElementVNode("div", {
                  class: "wl-taste-profile__aroma-img",
                  style: _normalizeStyle(`background: url(${aroma.image})`)
                }, null, 4 /* STYLE */),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, _toDisplayString(aroma.label), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[10] || (_cache[10] = _createTextVNode()),
    (_ctx.taste.style)
      ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
          (_ctx.isHeadlineVisible)
            ? (_openBlock(), _createElementBlock("header", _hoisted_11, _toDisplayString(_ctx.$t('wl_taste_profile.head.style.' + _ctx.taste.type.toUpperCase())), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _cache[8] || (_cache[8] = _createTextVNode()),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              class: "wl-taste-profile__style-img",
              src: _ctx.taste.style.image,
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_13),
            _cache[7] || (_cache[7] = _createTextVNode()),
            (_ctx.taste.style.taste || _ctx.taste.style.aftertaste)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_ctx.taste.style.taste)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('wl_taste_profile.style.taste')), 1 /* TEXT */),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("span", {
                          innerHTML: _ctx.taste.style.taste
                        }, null, 8 /* PROPS */, _hoisted_16)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _cache[6] || (_cache[6] = _createTextVNode()),
                  (_ctx.taste.style.aftertaste)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('wl_taste_profile.style.aftertaste')), 1 /* TEXT */),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("span", {
                          innerHTML: _ctx.taste.style.aftertaste
                        }, null, 8 /* PROPS */, _hoisted_18)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}